import BindCallToRequestFromList from './BindCallToRequestFromList';

export default BindCallToRequestFromList;
